
import Vue from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";
import { ComputeJob } from "../../model";
import { basename } from "../../util";
// import VueMarkdown from 'vue-markdown';

@Component({
  // components: {'vue-markdown': VueMarkdown},
  filters: {},
})
export default class DownloadHelpDialog extends Vue {
  @Prop({ type: String })
  tarballUrl: string;

  @Prop({ default: null, type: String })
  openFrom: string | null;

  @Prop({ default: null, type: String })
  closeTo: string | null;

  get filename() {
    return basename(new URL(this.tarballUrl).pathname);
  }

  get hasAccessToken() {
    return this.tarballUrl.includes("access_token=")
  }

  open() {
    // console.log('Opened: ' + refName);
    ((this.$refs as any)["thisDialog"] as any).open();
  }

  close() {
    // console.log('Closed: ' + refName);
    ((this.$refs as any)["thisDialog"] as any).close();
  }
}
